let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5jTsN")).then(() => parcelRequire('iI2wy'));